import React from 'react'

import { PdfViewer } from '@guiker/pdf-viewer'
import { PageLayout } from '@guiker/react-framework'

import { useLeaseContext } from '../../hooks'

export const ViewPdfLeaseScreen: React.FC = () => {
  const { downloadLink, navigateToBookingChat } = useLeaseContext()

  if (!downloadLink) return

  return (
    <PageLayout forceTakeover takeoverProps={{ onClose: navigateToBookingChat }}>
      <PdfViewer assetUrl={downloadLink} withDownload={true} />
    </PageLayout>
  )
}
